import config from '@/config'

export default {
	id: 'SIMPLE_PREMIUM_1M_44_1W_22',
	providers: {
		stripe: config('stripe_cheap_and_short'),
		braintree: 'pro_short_cheap',
		paltaMap: {
			USD: 'simple_premium_1m_44_1w_22_usd',
			EUR: 'simple_premium_1m_44_1w_22_eur',
			GBP: 'simple_premium_1m_44_1w_22_gbp',
			CAD: 'simple_premium_1m_72_1w_15_99_cad',
			AUD: 'simple_premium_1m_72_1w_15_99_aud',
			DKK: 'simple_premium_1m_379_1w_75_dkk',
			NOK: 'simple_premium_1m_579_1w_114_nok',
			SEK: 'simple_premium_1m_579_1w_114_sek',
			TRY: 'simple_premium_1m_1429_1w_325_try',
			BRL: 'simple_premium_1m_179_1w_34_brl',
			MXN: 'simple_premium_1m_729_1w_152_mxn',
			ARS: 'simple_premium_1m_58699_1w_12699_ars',
			COP: 'simple_premium_1m_175999_1w_38479_cop',
			CLP: 'simple_premium_1m_44000_1w_9220_clp',
		},
		primer: 'prd_w6vppNiqPBJC',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 1,
		intro_period_type: 'week',
		next_period_value: 1,
		next_period_type: 'month',
	},
	trial: {
		days: 7,
		priceMap: {
			USD: 22,
			EUR: 22,
			GBP: 22,
			CAD: 15.99,
			AUD: 15.99,
			DKK: 75,
			NOK: 114,
			SEK: 114,
			TRY: 325,
			BRL: 34,
			MXN: 152,
			ARS: 12699,
			COP: 38479,
			CLP: 9220,
		},
		originalPriceMap: {
			USD: 22,
			EUR: 22,
			GBP: 22,
			CAD: 15.99,
			AUD: 15.99,
			DKK: 75,
			NOK: 114,
			SEK: 114,
			TRY: 325,
			BRL: 34,
			MXN: 152,
			ARS: 12699,
			COP: 38479,
			CLP: 9220,
		},
	},
	subscription: {
		interval: 'month',
		intervalCount: 1,
		priceMap: {
			USD: 44,
			EUR: 44,
			GBP: 44,
			CAD: 72,
			AUD: 72,
			DKK: 379,
			NOK: 579,
			SEK: 579,
			TRY: 1429,
			BRL: 34,
			MXN: 729,
			ARS: 58699,
			COP: 175999,
			CLP: 44000,
		},
	},
	options: ($t, product, $tc) => ({
		explicitTermsPeriodText: $t('pages.program.organic.cheap_and_short.plans.7_days.into_period_text'), // 'first week'
		explicitTermsIntervalText: $tc('common.duration.month.base', 1), // 'month'
		billingSubtitlePeriodText: $t('pages.program.cheap_and_short.plans.7_days.into_period_text'), // 'first week'
		footerPeriodText: $t('pages.program.cheap_and_short.plans.7_days.period_text'), // '1-week'
		footerIntervalText: $t('pages.program.cheap_and_short.plans.7_days.sub_period_text'), // 'monthly'
	}),
}
